// extracted by mini-css-extract-plugin
export default {"newRow":"CampaignPlannerTable_newRow__9asKp","table":"CampaignPlannerTable_table__b6XAA"};